import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderContainerComponent } from './header/header.container.component';

@Component({
  selector: 'landing-page-ui',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
  imports: [RouterOutlet, HeaderContainerComponent],
  standalone: true,
})
export class LandingPageComponent {}
